import {
  ActiveRecord,
  ActiveRecords,
  BaseTableColumnWidget,
  CallChaining,
  Condition,
  FormFieldWidget,
  FormStringFieldSingleWidget,
  ModelFieldType,
  PushActiveRecordsPredict,
  QueryService,
  RuntimeContextManager,
  SPI,
  TableWidget,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';
import ContinuationInput from './ContinuationInput.vue';

export const DIALOG_VIEW_ACTION_NAME = '$$ContinuationInput_dialogViewAction';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Search,
    ttype: ModelFieldType.String,
    widget: 'ContinuationInput',
    multi: false
  })
)
export class SearchStringContinuationInputFieldWidget extends FormStringFieldSingleWidget {
  private activeRows: any = [];

  @Widget.Reactive()
  private columns: BaseTableColumnWidget[] = [];

  @Widget.Reactive()
  private showDialog = false;

  @Widget.Reactive()
  private tableData: ActiveRecord[] = [];

  @Widget.Reactive()
  private changeVisble(val) {
    this.showDialog = val;
  }

  private dbRowIndex: number | undefined;

  @Widget.Reactive()
  @Widget.Inject()
  protected refreshCallChaining: CallChaining | undefined;

  public initialize(props) {
    super.initialize(props);
    this.setComponent(ContinuationInput);
    return this;
  }

  @Widget.Method()
  public setRowClassName({ rowIndex }) {
    if (rowIndex === this.dbRowIndex) {
      return 'highlight';
    }
    return '';
  }

  @Widget.Method()
  private dblclick({ rowIndex }) {
    this.dbRowIndex = rowIndex;
  }

  public pushDataSource(records: ActiveRecords, predict?: PushActiveRecordsPredict) {
    super.pushDataSource(records, (currentRecords, record) => !currentRecords.some((v) => v.id === record.id));
  }

  @Widget.Method()
  protected async onEnter() {
    if (!this.value?.trim()) {
      return;
    }
    const requestFields = this.seekTableRuntimeContext().getRequestModelFields();
    const condition = new Condition(this.itemData).like(this.value!);
    condition.setConditionBodyData(this.initialContext as Record<string, unknown>);
    const result = (
      await QueryService.queryPage(this.model, {
        requestFields,
        currentPage: 1,
        pageSize: -1,
        condition
      })
    ).content;
    const totalElements = result.length;
    if (totalElements === 0) {
      OioNotification.error('错误', '无效的编码');
    } else if (totalElements === 1) {
      this.pushDataSource(result);
      this.refreshCallChaining?.syncCall();
    } else {
      this.columns = (
        Widget.select(this.seekTableRuntimeContext().handle)!.getChildren()[2] as TableWidget
      ).getColumnWidgets(true);
      this.tableData = result;
      this.showDialog = true;
    }
    this.setValue('');
  }

  private seekTableRuntimeContext() {
    const modelModel = this.model.model;
    if (modelModel) {
      const searchRuntimeContext = RuntimeContextManager.getOthers(this.metadataHandle)?.find(
        (v) => v.model.model === modelModel && v.view.type === ViewType.Table
      );
      if (searchRuntimeContext) {
        return searchRuntimeContext;
      }
    }
    return this.rootRuntimeContext;
  }

  @Widget.Method()
  private checkboxChange({ records }) {
    this.activeRows = records;
  }

  @Widget.Method()
  private editActived(dict) {
    const { row, column, rowIndex, columnIndex } = dict;
  }

  @Widget.Method()
  private async editClosed(dict) {
    const { row, column, rowIndex, columnIndex } = dict;
  }
}
